$(document).on("turbolinks:load", () => {
    // 未入力アラート
    $(".new_adult_personal_information, .edit_adult_personal_information, .new_child_personal_information, .edit_child_personal_information").validationEngine({
        promptPosition: "topLeft",
        scrollOffset: 200
    });

    if ($("#personal-new").length != 0){
        let box = document.getElementById('rule-block');
        box.onscroll = (event) => {
            if (event.target.clientHeight + event.target.scrollTop + 1 > event.target.scrollHeight) {
                document.getElementById('check-personal').disabled = false;
            }       
        }
    }
    
    $('input[type="checkbox"]#check-personal').click(function() {
        $("#submit-personal").remove()
        if ($(this)[0].checked){
            var html = `<input type="submit" name="commit" value="利用開始する" class="button button-lg" id="submit-personal" data-disable-with="利用開始する" />`
            $(".card").append(html)
        }else{
            var html = `<div class="button button-lg button-gray" id="submit-personal">利用開始する</div>`
            $(".card").append(html)
        }
        
    });

    $("input[name*='personal_information']").keydown(function(e) {
        if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
            return false;
        } else {
            return true;
        }
    });
})  